import { useMemo } from 'preact/hooks';

import { CurrencyService } from './currency.service';

const currencyService = new CurrencyService();

export function useShopifyCurrency() {
  return useMemo(
    () => ({
      shopifyCurrency: (value, inCents = true) => {
        const currency = currencyService.getCurrency();
        const locale = getLocaleFromCurrency(currency);
        const amount = inCents ? value / 100 : value;

        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
        }).format(amount);
      },
      formatMoney: (cents, format) => currencyService.formatMoney(cents, format),
      getSymbol: () => currencyService.getSymbol(),
      getCurrency: () => currencyService.getCurrency(),
    }),
    []
  );
}

const getLocaleFromCurrency = (currency) => {
  const localeMap = {
    USD: 'en-US',
    EUR: 'de-DE',
    GBP: 'en-GB',
    CAD: 'en-CA',
    // Add more mappings as needed
  };
  return localeMap[currency] || 'en-US';
};

// Usage in component:
// const { shopifyCurrency } = useShopifyCurrency();
// <div>{shopifyCurrency(2999)}</div> // 2999 cents = $29.99 (default)
// <div>{shopifyCurrency(29.99, false)}</div> // Already in dollars
